import { Attention as AttentionType, FormConfig, FormValues } from '@topdanmark-onlinesolutions/claim-form-types';
import { Message } from '@flos/react-ui';

const Attention = ({ value, theme }: AttentionType) => {
    return (
        <div className="u-spacing-stack-l">
            <Message theme={theme}>{value}</Message>
        </div>
    );
};

Attention.isValid = (formConfig: FormConfig, formValues: FormValues, elementId: string): boolean => {
    return true;
};

export default Attention;
